module.exports = __webpack_public_path__ + "static/media/shield.262eeaee.svg";